// This file is generated by the schema import script.

import activityLog from './activity_log.json';
import alarms from './alarms.json';
import bookmarks from './bookmarks.json';
import action from './action.json';
import browserAction from './browser_action.json';
import browserSettings from './browser_settings.json';
import browsingData from './browsing_data.json';
import captivePortal from './captive_portal.json';
import chrome_settings_overrides from './chrome_settings_overrides.json';
import clipboard from './clipboard.json';
import commands from './commands.json';
import contentScripts from './content_scripts.json';
import contextualIdentities from './contextual_identities.json';
import cookies from './cookies.json';
import declarativeNetRequest from './declarative_net_request.json';
import devtools from './devtools.json';
import dns from './dns.json';
import downloads from './downloads.json';
import events from './events.json';
import experiments from './experiments.json';
import extension from './extension.json';
import extension_protocol_handlers from './extension_protocol_handlers.json';
import extensionTypes from './extension_types.json';
import find from './find.json';
import geckoProfiler from './geckoProfiler.json';
import history from './history.json';
import i18n from './i18n.json';
import identity from './identity.json';
import idle from './idle.json';
import management from './management.json';
import contextMenus from './context_menus.json';
import menus from './menus.json';
import native_manifest from './native_manifest.json';
import networkStatus from './network_status.json';
import normandyAddonStudy from './normandyAddonStudy.json';
import notifications from './notifications.json';
import omnibox from './omnibox.json';
import pageAction from './page_action.json';
import permissions from './permissions.json';
import pkcs11 from './pkcs11.json';
import privacy from './privacy.json';
import proxy from './proxy.json';
import runtime from './runtime.json';
import scripting from './scripting.json';
import search from './search.json';
import sessions from './sessions.json';
import sidebarAction from './sidebar_action.json';
import storage from './storage.json';
import tabGroups from './tabGroups.json';
import tabs from './tabs.json';
import telemetry from './telemetry.json';
import test from './test.json';
import theme from './theme.json';
import topSites from './top_sites.json';
import trial from './trial_ml.json';
import types from './types.json';
import url_overrides from './url_overrides.json';
import userScripts from './userScripts.json';
import webNavigation from './web_navigation.json';
import webRequest from './web_request.json';
import windows from './windows.json';
export default [
  activityLog,
  alarms,
  bookmarks,
  action,
  browserAction,
  browserSettings,
  browsingData,
  captivePortal,
  chrome_settings_overrides,
  clipboard,
  commands,
  contentScripts,
  contextualIdentities,
  cookies,
  declarativeNetRequest,
  devtools,
  dns,
  downloads,
  events,
  experiments,
  extension,
  extension_protocol_handlers,
  extensionTypes,
  find,
  geckoProfiler,
  history,
  i18n,
  identity,
  idle,
  management,
  contextMenus,
  menus,
  native_manifest,
  networkStatus,
  normandyAddonStudy,
  notifications,
  omnibox,
  pageAction,
  permissions,
  pkcs11,
  privacy,
  proxy,
  runtime,
  scripting,
  search,
  sessions,
  sidebarAction,
  storage,
  tabGroups,
  tabs,
  telemetry,
  test,
  theme,
  topSites,
  trial,
  types,
  url_overrides,
  userScripts,
  webNavigation,
  webRequest,
  windows,
];
